import { render, staticRenderFns } from "./memberInfo.vue?vue&type=template&id=289f59ee&"
import script from "./memberInfo.vue?vue&type=script&lang=js&"
export * from "./memberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports